import { maybeGetGlobal } from '../globals';
var X_WIX_BRAND_NAME = 'x-wix-brand';
export function xWixBrand() {
    var _a;
    var value = extractBrand();
    return _a = {}, _a[X_WIX_BRAND_NAME] = value, _a;
}
function extractBrand() {
    var globalObj = maybeGetGlobal();
    if (globalObj &&
        globalObj.commonConfig &&
        typeof globalObj.commonConfig.brand === 'string') {
        return globalObj.commonConfig.brand;
    }
    return '';
}
//# sourceMappingURL=x-wix-brand.js.map